
export class Jurisdicionado {
    id: number;
    codJurisdicionado: number;
    dsJurisdicionado: string;
    tipoEntidade: any;

    constructor() {
        this.id = 0;
        this.codJurisdicionado = 0;
        this.dsJurisdicionado="";
        this.tipoEntidade = {
            id: "",
            dsTipoEntidade: ""
        };        
    }

    public setJurisdicionado(idJurisdicionado, dsJurisdicionado){
        this.id = idJurisdicionado;
        this.codJurisdicionado = idJurisdicionado;
        this.dsJurisdicionado = dsJurisdicionado;
        this.tipoEntidade = {
            id: 0,
            dsTipoEntidade: ""
        }
    }

}


// WEBPACK FOOTER //
// ./src/models/Jurisdicionado.ts